import axios from "axios";

// Create axios interceptor to automatically add auth token to all requests
axios.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("auth_token");

    // If token exists, add it to the headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: Add response interceptor to handle common auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // If we get a 401 error, we could redirect to login
    if (error.response?.status === 401) {
      console.warn("Authentication error - token may be expired");
      // Optionally force logout or redirect to login
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
